import './vue-echo'

window.$ = window.jQuery = require('jquery')
import Popper from 'popper.js'
import 'bootstrap'
import moment from 'moment-timezone'

window.moment = moment
window.Popper = Popper

